var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgramming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 722.064,
    height: 525.16,
    viewBox: "0 0 722.064 525.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "programming",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 24.503,
    cy: 24.503,
    r: 24.503,
    transform: "translate(396.097 43.573)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M820.832,622.8c36.421-27.741,53.817-74.357,42.927-118.826q-.406-1.657-.857-3.307c-7.22-26.4-25.082-51.484-51.116-59.918-21.859-7.082-45.719-1.636-68.524-4.452-44.766-5.528-79.473-41.75-103.894-79.674s-43.189-80.375-75.638-111.706c-53.488-51.644-140.74-62.763-207.058-29.147S248.112,323.968,249.913,398.3s45.927,145.393,110.009,183.1c23.541,13.851,50.768,23.663,77.865,20.23,23.511-2.979,44.875-15.612,68.275-19.363,36.792-5.9,73.349,10.738,105.171,30.122s62.56,42.361,98.72,51.347C745.067,672.455,788.567,647.374,820.832,622.8Z",
    transform: "translate(-210.151 -166.564)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M779.265,214.638c-.8-.532-1.606-1.037-2.4-1.551a348.947,348.947,0,0,0-73.7-35.726l-6,82.795H659.111V165.275c-2.4-.5-4.809-.964-7.222-1.4v96.285H606.674A93.853,93.853,0,0,1,512.82,166.3h0c-2.423.523-4.827,1.083-7.231,1.679v92.174H468.762l-5.717-78.95a349.514,349.514,0,0,0-75.2,39.947c-.4.275-.808.56-1.2.835-2.028,1.422-4.029,2.872-6.02,4.341V542.192H489.162l-1.918-26.567L476.691,369.757h212.53L678.667,515.625l-1.918,26.567H784.083V217.832Q781.688,216.207,779.265,214.638ZM505.589,345.667H474.947l-5.662-78.28h36.3Zm146.3,0H600.424v-1.551a5.671,5.671,0,0,0-5.68-5.671H572.37a5.669,5.669,0,0,0-5.671,5.671v1.551H512.82v-78.28H651.889Zm7.222,0v-78.28h37.525l-5.662,78.28Z",
    transform: "translate(-220.913 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M206.59,598.162A265.225,265.225,0,0,0,232.4,624.729l670.453.918a265.217,265.217,0,0,0,25.806-26.567Z",
    transform: "translate(-206.59 -199.614)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M702.02,505.123v78.65a3.783,3.783,0,0,0,3.78,3.78H822.351a3.783,3.783,0,0,0,3.78-3.78v-78.65a3.785,3.785,0,0,0-3.78-3.776H705.8A3.785,3.785,0,0,0,702.02,505.123Z",
    transform: "translate(-247.364 -191.646)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M705,506.347v76.7a2.023,2.023,0,0,0,2.02,2.02H821.627a2.024,2.024,0,0,0,2.02-2.02v-76.7a2.025,2.025,0,0,0-2.02-2.024H707.02A2.025,2.025,0,0,0,705,506.347Z",
    transform: "translate(-247.61 -191.891)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M699.318,606.721a2.267,2.267,0,0,0,1.784.853H825.9a2.3,2.3,0,0,0,2.245-2.767l-1.937-9.2a2.3,2.3,0,0,0-1.43-1.668,2.223,2.223,0,0,0-.815-.154H703.031a2.232,2.232,0,0,0-.815.154,2.3,2.3,0,0,0-1.43,1.668l-1.937,9.2A2.294,2.294,0,0,0,699.318,606.721Z",
    transform: "translate(-247.099 -199.253)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(575.977 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(568.29 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(560.602 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(552.915 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(545.227 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(537.54 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(529.852 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(522.165 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(514.477 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(506.789 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(499.102 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(491.414 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(483.727 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(476.039 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(468.352 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(460.664 398.493) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(576.068 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(568.381 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(560.693 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(553.006 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(545.318 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(537.63 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(529.943 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(522.255 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(514.568 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(506.88 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(499.193 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(491.505 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(483.818 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(476.13 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(468.443 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 3.844,
    height: 2.306,
    rx: 0.488,
    transform: "translate(460.755 402.336) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 30.75,
    height: 2.306,
    rx: 0.488,
    transform: "translate(539.168 406.949) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(473.194 329.213)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(503.04 329.213)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(511.497 329.213)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(481.312 328.974)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(521.107 328.974)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(481.153 335.68)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(511 335.68)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(519.456 335.68)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(489.271 335.44)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(529.066 335.44)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(489.112 342.146)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(518.959 342.146)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(527.415 342.146)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(497.23 341.907)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(537.026 341.907)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(497.071 348.613)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(526.917 348.613)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(535.374 348.613)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(505.19 348.374)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(503.04 374.328)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(511.497 374.328)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(521.107 374.566)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(473.194 374.328)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(481.312 374.566)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(481.153 367.861)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(511 367.861)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(519.456 367.861)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(489.271 368.099)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(489.112 361.394)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(518.959 361.394)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(527.415 361.394)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(497.23 361.632)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(497.071 354.927)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(526.917 354.927)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 5.475,
    height: 2.865,
    rx: 1.433,
    transform: "translate(535.374 354.927)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 19.085,
    height: 2.865,
    rx: 1.433,
    transform: "translate(505.19 355.166)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M710.408,647.77,698.158,628.4l38.453-30.654,15.872-17.584a17.584,17.584,0,0,1,29.75,6.266h0a17.584,17.584,0,0,1-10.618,22.016l-25.1,9.246Z",
    transform: "translate(-247.047 -197.655)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M398.28,501.067v94.119h65.937V501.067a3.164,3.164,0,0,0-2.23-3.029,2.916,2.916,0,0,0-.945-.147H401.464A3.178,3.178,0,0,0,398.28,501.067Zm25.732,32.34a7.039,7.039,0,1,1,14.078,0v10.921a7.039,7.039,0,1,1-14.078,0Z",
    transform: "translate(-222.366 -191.361)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M398.06,600.632v9.076a1.786,1.786,0,0,0,1.771,1.78h62.8a1.78,1.78,0,0,0,1.771-1.78v-9.076Z",
    transform: "translate(-222.348 -199.817)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M285.25,346.092V517.94a8.266,8.266,0,0,0,8.259,8.259H548.171a8.266,8.266,0,0,0,8.259-8.259V346.092a8.27,8.27,0,0,0-8.259-8.25H293.509A8.27,8.27,0,0,0,285.25,346.092Z",
    transform: "translate(-213.064 -178.189)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M291.76,348.765v167.59a4.422,4.422,0,0,0,4.414,4.414H546.587A4.422,4.422,0,0,0,551,516.355V348.765a4.423,4.423,0,0,0-4.414-4.423H296.174A4.424,4.424,0,0,0,291.76,348.765Z",
    transform: "translate(-213.6 -178.724)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M342.345,610.407a2.707,2.707,0,0,0,2.129,1.019H493.453a2.741,2.741,0,0,0,2.68-3.3l-2.313-10.985a2.747,2.747,0,0,0-1.707-1.991,2.657,2.657,0,0,0-.973-.184H346.777a2.654,2.654,0,0,0-.973.184,2.746,2.746,0,0,0-1.707,1.991l-2.313,10.985A2.74,2.74,0,0,0,342.345,610.407Z",
    transform: "translate(-217.712 -199.35)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M539.488,369.332H305.177a.932.932,0,1,1,0-1.864H539.488a.932.932,0,1,1,0,1.864Z",
    transform: "translate(-214.627 -180.627)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 5.461,
    cy: 5.582,
    rx: 5.461,
    ry: 5.582,
    transform: "translate(101.039 170.919)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.461,
    cy: 5.582,
    rx: 5.461,
    ry: 5.582,
    transform: "translate(119.903 170.919)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.461,
    cy: 5.582,
    rx: 5.461,
    ry: 5.582,
    transform: "translate(138.768 170.919)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M546.916,351.622h-13.4a1.014,1.014,0,0,0,0,2.028h13.4a1.014,1.014,0,0,0,0-2.028Z",
    transform: "translate(-233.415 -179.323)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M546.913,355.772h-13.4a1.014,1.014,0,1,0,0,2.028h13.4a1.014,1.014,0,1,0,0-2.028Z",
    transform: "translate(-233.413 -179.665)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M546.916,359.922h-13.4a1.014,1.014,0,0,0,0,2.028h13.4a1.014,1.014,0,0,0,0-2.028Z",
    transform: "translate(-233.415 -180.006)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M899.576,599.914a5.889,5.889,0,0,0,5.674,3.975l24.311-.626a5.808,5.808,0,0,0,5.489-4.274l3.44-36.788a8.986,8.986,0,0,0,3.889.8,8.866,8.866,0,0,0-.445-17.727,7.5,7.5,0,0,0-1.593.166,6.009,6.009,0,0,0-4.473-1.93l-37.4.966a5.385,5.385,0,0,0-.922.114,5.84,5.84,0,0,0-4.472,7.585ZM939.2,559.7l2.448-8.767a5.968,5.968,0,0,0,.019-3.1c.119,0,.224-.056.343-.057a6.342,6.342,0,1,1,.3,12.68,5.971,5.971,0,0,1-3.106-.759Z",
    transform: "translate(-263.064 -195.116)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M897.978,544.589c.8,4.556,9.754,7.758,20.525,7.2,9.9-.457,18-3.934,19.487-8.056a5.533,5.533,0,0,0-1.693-.225l-37.4.966A5.389,5.389,0,0,0,897.978,544.589Z",
    transform: "translate(-263.492 -195.115)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M922.424,582.231a.449.449,0,0,0,.138-.061l5.28-3.456a.458.458,0,0,0,0-.767l-5.488-3.594a.459.459,0,0,0-.5.767l4.9,3.21L922.06,581.4a.459.459,0,0,0,.364.829Z",
    transform: "translate(-265.44 -197.648)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M912.866,582.65a.459.459,0,0,0,.116-.843l-4.866-2.79,4.7-3.494a.459.459,0,0,0-.547-.736l-5.266,3.912a.458.458,0,0,0,.045.766l5.474,3.138A.46.46,0,0,0,912.866,582.65Z",
    transform: "translate(-264.22 -197.682)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M921.2,585.059a.44.44,0,0,0,.126-.053.459.459,0,0,0,.154-.63l-7.484-12.3a.459.459,0,1,0-.784.478l7.484,12.3A.46.46,0,0,0,921.2,585.059Z",
    transform: "translate(-264.74 -197.448)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 46.545,
    height: 9.953,
    rx: 3.264,
    transform: "translate(192.152 239.361)",
    fill: "#16c389"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 93.822,
    height: 9.953,
    rx: 3.264,
    transform: "translate(168.513 259.267)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 93.822,
    height: 9.953,
    rx: 3.264,
    transform: "translate(168.513 279.173)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M497.3,536.145l.2.628.01.021L503.5,555l6.888,20.979,12.96,39.426.126,6.124v.021l.963,49.266-2.67,6.679,3,10.95s-1.382-16.553-8.794-7.047c-4.2,5.4-9.108,10.929-13.138,16.111q8.81,3.565,17.9,6.449c1.309.419,2.628.817,3.947,1.214l.848.251a244.9,244.9,0,0,0,61.808,9.935c1.088.031,2.156.052,3.193.073.367.01.722.021,1.078.021,1.173.011,2.334.021,3.507.021q3.549,0,7.067-.1a244.889,244.889,0,0,0,51.475-6.962c-.115-6.962-.429-15.1-.88-23.785-.209-4.261-4.91-8.878-5.192-13.337-.2-3.35,4.02-6.5,3.8-9.9-1.424-20.948-3.2-12.907-4.523-27.741q-.2-2.183-.377-4.177c-.848-9.527-1.434-15.484-1.434-15.484l5.632-35.5,8.846-55.736-.68-1.12-.764-.377-46.66-23.094-2.533-6.491a10.075,10.075,0,0,0-9.307-6.376l-30.737-.126a10.032,10.032,0,0,0-8.176,4.156l-8.323,11.526Z",
    transform: "translate(-230.516 -190.314)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M527.554,609.835l-6.963,14.9-4.753,10.176-8.176,42.807-4.093,4.345-3.507-15.38-36.706,8.15c-1.2-6.689-.322.226-1.066-7.112.21-.209.429-.419.649-.628.586-.544,1.078-1.057,1.068-1.549-.419-25.314.837-68.393,11.327-94.492a55.114,55.114,0,0,1,6.449-12.029c.209-.283.408-.565.607-.848,4.837-6.773,7.893-13.442,12.228-18.184v-.01a.485.485,0,0,0,.073-.073.145.145,0,0,0,.042-.031l29.773-15.787,1.277,35.887.911,25.8Z",
    transform: "translate(-227.634 -193.517)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M650.391,614.1l8.7,18.606,3.035,6.48,8.174,42.8,4.08,4.334,3.515-15.376,1.652-.339,29.787-6.169,8.682,27.573a16.5,16.5,0,0,0-2.993-20.653c-.593-.536-1.087-1.059-1.073-1.553.494-29.773-1.327-84.138-17.774-106.514-5.223-7.1-8.357-14.174-12.917-19.115-.014-.014-.014-.028-.028-.028l-11.1-18.168-.678-1.115-.762-.381Z",
    transform: "translate(-243.115 -193.55)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 40.891,
    cy: 40.891,
    r: 40.891,
    transform: "translate(313.705 204.319)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M644.131,397.1a3.45,3.45,0,0,0-2.469-1.092l.615-1.707a3.237,3.237,0,0,0-3.634-4.313l-2.239.431.211-1.5a3.243,3.243,0,0,0-4.341-3.506,3.456,3.456,0,0,1-2.973-.211,3.53,3.53,0,0,1-1.762-2.4l-.78-3.763-.083-.2c-3.8-6.332-11.1-10.939-20.043-12.628-7.956-1.514-16.115-.743-23.979-.018-3.12.294-6.644.624-9.581,2.423-2.5,1.542-4.607,4.625-4.176,7.736-7.754-2.377-16.069,2.368-20.189,8.351-4.882,7.121-5.681,16.041-5.809,23.016-.349,16.5,3.056,30,10.094,40.131.514.734.642,2.267,1.661,2.781l-.211-.34c1.138.569,2.294,1.487,1.863,2.469-1.239,2.827,6.993,9.076,12.793,11.141,10.581,3.772,24.649,3.451,34.542,2.092l.349-2.34c3.57-.486,6.085-1.413,6.791-2.863,1.248-1.065,2.313-2.019,3.24-2.9l.009-.009c.018-.018.055-.046.073-.064,4.469-4.286,5.506-6.727,5.974-10.443.45-3.643-.349-7.342-1.165-10.673,17.2,2.661-6.773-18.317,9.25-22.374a5.009,5.009,0,0,1,.56-.138c.468-.11.936-.22,1.386-.349a24.277,24.277,0,0,0,6.167-2.634c4.478-2.726,5.956-6.341,8.269-10.416A3.145,3.145,0,0,0,644.131,397.1Z",
    transform: "translate(-234.267 -180.453)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M726.434,620.018c-.009,1.606-.027,3.854-.1,6.635q-.014.579-.028,1.184c-.119,5.112-.238,9.4-.431,14.16-.009.33-.018.652-.037.982-.257,6.644-.661,14.38-1.358,26.632-1.294,22.63-3.552,3.111-5.818,11.049-.11.395-.229.863-.339,1.413a25.618,25.618,0,0,1-1.725,5.809c-1.2.716-2.441,1.4-3.662,2.093-3.478,1.936-7.011,3.8-10.572,5.57-2,.991-4.01,1.964-6.029,2.9-.321.147-.633.294-.945.431a248.617,248.617,0,0,1-31.89,12.169c-2.129.643-4.249,1.267-6.4,1.845-2.239.624-4.478,1.212-6.745,1.762a244.928,244.928,0,0,1-51.474,6.965c-2.34.073-4.7.1-7.066.1-1.175,0-2.331-.009-3.506-.018-.358,0-.716-.009-1.074-.018-1.037-.028-2.111-.046-3.194-.074a244.7,244.7,0,0,1-61.807-9.939l-.853-.248c-1.322-.4-2.634-.8-3.946-1.221q-9.085-2.877-17.9-6.442-6.731-2.712-13.306-5.818a.312.312,0,0,1-.11-.055c-.918-.422-1.845-.863-2.763-1.313-.119-.064-.248-.128-.376-.193q-5.135-2.505-10.159-5.249c-2.817-6.47-6.782-7.709-9.241-13.4a23.735,23.735,0,0,1-1.542-5.268c0-.018-.009-.037-.009-.064.257,3.414-1.092-6.056-.009-.036-.009-.11-.018-.229-.027-.367-.027-.33-.064-.734-.119-1.239-3.148-30.734-2.946-65.882-4.313-94.844q-.138-2.808-.284-5.378c-.028-.569-.064-1.129-.1-1.68.064-.165.138-.34.22-.5a.9.9,0,0,1,.064-.138,1.469,1.469,0,0,1,.092-.165c.018-.028.046-.064.064-.092a.858.858,0,0,1,.046-.092c.083-.128.174-.266.276-.395.046-.055.082-.1.128-.147a.731.731,0,0,1,.11-.129.583.583,0,0,1,.1-.12c.037-.036.073-.082.119-.128a.274.274,0,0,1,.073-.073,1.846,1.846,0,0,1,.239-.229,8.8,8.8,0,0,1,1.046-.826c.128-.083.266-.165.395-.257a17.537,17.537,0,0,1,2.909-1.395c.349-.129.7-.248,1.074-.376.138-.036.266-.082.4-.128.2-.064.4-.128.615-.174,1.046-.312,2.175-.578,3.4-.826.147-.027.3-.055.459-.092.22-.046.45-.083.679-.12l.955-.165c2.725-.431,5.818-.752,9.232-.964l.964-.055,1.138-.055c.321-.018.652-.027.982-.036s.651-.028.991-.037c.927-.028,1.881-.055,2.854-.073,2.771-.055,5.69-.037,8.755.027,1.422.037,2.872.073,4.359.138.1,0,.193.009.284.009,1.294.046,2.6.1,3.937.174.936.046,1.881.091,2.827.147.89.055,1.789.11,2.7.175.707.036,1.413.092,2.129.138.606.046,1.211.092,1.817.128l.826.055c.45.037.9.064,1.358.11l3.047.248,3.093.275c1.037.092,2.083.193,3.129.294l.312.028c.955.1,1.909.192,2.873.294.22.018.45.036.67.064.919.092,1.855.2,2.783.3l.853.092c.726.079,1.442.148,2.173.234.964.11,1.946.211,2.9.339.743.083,1.487.165,2.23.257,1.166.138,2.349.284,3.533.44.45.055.9.11,1.349.174,3.377.422,6.791.89,10.26,1.377,5.259.743,10.6,1.551,15.977,2.423s10.8,1.792,16.253,2.762c1.377.248,2.753.5,4.139.752l1.872.358c1.064.193,2.129.395,3.194.6s2.129.4,3.193.615l3.809.743c8.342,1.652,16.638,3.414,24.732,5.258,1.331.3,2.661.615,3.983.918q3.965.922,7.856,1.872c.716.165,1.422.34,2.129.514,1.762.44,3.524.881,5.258,1.331l.3.083c1.276.312,2.524.633,3.772.963q4.419,1.157,8.69,2.34,2.836.785,5.607,1.588c2.762.8,5.469,1.606,8.1,2.423.652.2,1.3.4,1.945.6,1.927.6,3.827,1.2,5.671,1.808,1.469.477,2.9.964,4.313,1.45s2.8.973,4.157,1.459c.872.312,1.734.642,2.6.954,1.239.459,2.46.918,3.653,1.377.367.138.725.285,1.083.422.229.1.45.183.67.275.431.174.872.339,1.294.514s.854.34,1.276.523c.413.165.835.339,1.239.514s.817.34,1.22.523c.339.138.67.284.991.431.651.285,1.3.569,1.936.863.312.147.624.285.936.431l.716.33c.1.055.2.1.3.147.229.11.468.229.7.339.532.248,1.056.514,1.569.762.688.349,1.358.7,2,1.037s1.285.7,1.89,1.037c.1.055.193.11.294.165.138.073.275.156.413.229.468.266.918.542,1.367.807.881.542,1.716,1.074,2.5,1.606.174.119.34.239.514.349.578.413,1.129.817,1.643,1.23,0,.009,0,.009.009.009.174.128.339.266.5.395.138.128.285.239.422.367.477.413.918.808,1.322,1.211a5.175,5.175,0,0,1,.385.395,1.1,1.1,0,0,1,.147.147c.183.183.349.367.5.551a.529.529,0,0,1,.064.083c.22.257.422.514.615.771.092.128.193.257.275.385.11.156.22.321.312.477.082.129.156.266.229.395a6.683,6.683,0,0,1,.5,1.037,4.8,4.8,0,0,1,.248.753A5.337,5.337,0,0,1,726.434,620.018Z",
    transform: "translate(-227.213 -196.558)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M726.433,620.019c-.009,1.606-.028,3.854-.1,6.635-.009.385-.028.78-.037,1.184-.092,3.9-.229,8.718-.422,14.16-.009.33-.018.651-.037.982-.257,6.644-.661,14.38-1.358,26.632-1.294,22.631-3.552,3.111-5.818,11.049-6.3-3.873-13.2-7.929-20.575-12.1q-2-1.129-4.029-2.267c-14.757-8.232-31.238-16.858-48.445-25.4-.679-.339-1.367-.679-2.047-1.009-39.415-19.483-82.437-38.433-117.291-51.079-6.727-2.441-13.151-4.644-19.189-6.58-12.719-4.065-23.713-6.91-32.174-8.14-8.81-1.285-14.894-.826-17.354,1.826q-.138-2.808-.285-5.378-.055-.853-.11-1.68c.057-.151.13-.3.2-.44.01-.021.018-.043.028-.064a.907.907,0,0,1,.064-.138,1.507,1.507,0,0,1,.092-.165.984.984,0,0,1,.11-.183c.083-.128.174-.266.275-.395a3.268,3.268,0,0,1,.239-.276.586.586,0,0,1,.1-.119c.037-.037.073-.082.119-.128a.276.276,0,0,1,.073-.074,1.905,1.905,0,0,1,.239-.229,8.828,8.828,0,0,1,1.046-.826c.128-.083.266-.165.395-.257a17.563,17.563,0,0,1,2.909-1.4c.349-.128.7-.248,1.074-.376.138-.037.266-.083.4-.128.2-.064.4-.129.615-.175,1.046-.312,2.175-.578,3.4-.826.367-.074.752-.147,1.138-.211.312-.055.633-.11.955-.165,2.725-.431,5.818-.753,9.232-.964l.964-.055,1.138-.055c.321-.019.652-.028.982-.037s.652-.028.991-.037c.927-.028,1.881-.055,2.854-.073,2.771-.046,5.69-.028,8.755.037,1.422.028,2.872.073,4.359.138.092,0,.193.009.284.009,1.294.037,2.606.1,3.937.165.936.046,1.881.092,2.827.147.89.055,1.789.11,2.7.174.707.037,1.413.092,2.129.138.606.046,1.211.092,1.817.129l2.184.165c1.009.083,2.019.165,3.047.248l3.093.275c1.037.092,2.083.193,3.129.294l.312.028c.954.1,1.909.193,2.872.294q8.012.812,16.491,1.9,5.066.647,10.26,1.386c5.258.743,10.6,1.551,15.977,2.413s10.8,1.793,16.253,2.763c1.376.248,2.753.5,4.139.752q2.533.468,5.066.955c1.065.2,2.129.4,3.194.615l3.808.743c8.342,1.652,16.638,3.414,24.732,5.258,1.331.3,2.661.615,3.983.918q3.965.922,7.855,1.872c.716.174,1.422.349,2.129.523q2.657.661,5.258,1.321v.009c.1.019.2.046.3.073,1.266.321,2.524.642,3.772.973q4.419,1.156,8.691,2.331c1.89.532,3.763,1.055,5.607,1.588,2.762.808,5.469,1.615,8.1,2.423.652.2,1.3.4,1.946.6q2.891.908,5.671,1.808c1.468.477,2.9.963,4.313,1.45s2.8.973,4.157,1.459c.881.312,1.743.633,2.6.945,1.248.459,2.459.918,3.652,1.386.367.138.725.284,1.083.422.67.257,1.322.523,1.964.789.431.165.854.339,1.276.523.413.165.835.34,1.239.514s.817.339,1.221.523c.34.138.67.285.991.432.652.284,1.3.569,1.936.863.312.147.624.284.936.431l.716.33c.1.055.2.1.3.147.78.367,1.532.734,2.267,1.1.688.349,1.358.7,2,1.037.762.4,1.487.8,2.184,1.2.138.073.275.156.413.23.468.266.918.541,1.368.807.881.541,1.716,1.074,2.5,1.606s1.487,1.055,2.156,1.578c0,.009,0,.009.009.009.321.257.633.514.927.762.477.413.918.807,1.321,1.211a5.214,5.214,0,0,1,.385.395,1.088,1.088,0,0,1,.147.147c.193.211.385.422.569.633.22.257.422.514.615.771.092.128.193.257.275.385.11.156.22.321.312.477.083.129.156.266.229.395a6.656,6.656,0,0,1,.5,1.037,5.507,5.507,0,0,1,.248.752A5.341,5.341,0,0,1,726.433,620.019Z",
    transform: "translate(-227.212 -196.559)",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramming);
export default __webpack_public_path__ + "static/media/programming.8daed778368bd957bc4a38aaf0308dc0.svg";
export { ForwardRef as ReactComponent };